import { ContentDto } from '@diritto/common/content/dtos/content.dto';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { BadgeType } from 'constants/cover';
import { useAuthState } from 'contexts/AuthProvider';
import { useContentState } from 'state-hooks/contents/useContentState';
import { CoverBadge } from 'ui-components/common/CoverBadge';
import { HiddenReservationBadge } from 'ui-components/contents/HiddenReservationBadge';

const variant = {
  container: {
    topLeft: 'absolute top-0 left-0 flex gap-0.5 p-1 z-[100]',
    topRight: 'absolute top-0 right-0 flex gap-0.5 p-1 z-[100]',
    bottomLeft: 'absolute bottom-0 left-0 flex gap-0.5 p-1 z-[100]',
    bottomRight: 'absolute bottom-0 right-0 flex gap-0.5 p-1 z-[100]',
    bottom: 'absolute bottom-0 right-0 left-0 z-[100]',
  },
  hidden: 'rounded-[2px] border-[0.5px] border-white/10 bg-gray-600',
} as const;

interface ContentCoverBadgeProps {
  content: ContentDto | ContentPublicRelayDto;
  isContestActive?: boolean;
}

export const ContentCoverBadge = ({ content, isContestActive }: ContentCoverBadgeProps) => {
  const { partner } = useAuthState();
  const showPartner = !!(partner && partner.verifiedAt);
  const state = useContentState(content);

  return (
    <>
      <div className={variant.container.topLeft}>
        {state.isDirittoOnly && <CoverBadge type={BadgeType.DirittoOnly} />}
        {state.isDirittoOriginal && <CoverBadge type={BadgeType.DirittoOriginal} />}
        {state.isContestWinner && <CoverBadge type={BadgeType.Contest} />}
        {state.isNew && <CoverBadge type={BadgeType.New} />}
        {state.isUpdated && <CoverBadge type={BadgeType.Up} />}
        {state.isCompleted && <CoverBadge type={BadgeType.Completed} />}
        {state.isPublished && <CoverBadge type={BadgeType.Published} />}
      </div>

      <div className={variant.container.topRight}>{state.isAdult && <CoverBadge type={BadgeType.Adult} />}</div>

      <div className={variant.container.bottomRight}>
        {state.showHiddenReservationBadge && (
          <HiddenReservationBadge reservedHideContentsDiffDays={state.reservedHideContentsDiffDays} />
        )}
        {state.isHidden && <CoverBadge type={BadgeType.Hidden} className={variant.hidden} />}
      </div>

      <div className={variant.container.bottomLeft}>
        {showPartner && state.isProposalWanted && <CoverBadge type={BadgeType.ProposalWanted} />}
      </div>
      <div className={variant.container.bottom}>
        {isContestActive && <CoverBadge type={BadgeType.ContestChallenge} />}
      </div>
    </>
  );
};
